import { RewardType } from '@partnerka-front/types';

export const handleRewardType = (type: RewardType | string) => {
  if (type === RewardType.CPA_BASELINE) return 'CPA – Baseline';
  if (type === RewardType.CPA_MIN_DEPOSIT) return 'CPA – Min deposit';

  return type;
};
